module.exports = __webpack_public_path__ + "static/sane_blue-684382a6f62173c6460cc339c04a8b6e.jpg";